// Hosted on the shared static-assets CloudFront distribution, the same file the
// product emails use, so a logo change is one upload instead of a rebuild.
export const APEXIA_LOGO_URL = 'https://d3dg1lmpu1jt4g.cloudfront.net/email-assets/apexia-logo-dark.png';
